import React, { CSSProperties } from "react";

import { css } from "@emotion/react";

import { ReactTFC } from "../../utils/fp/missing-ts-parts";
import { ContentfulComponentCMSHook } from "@swo/shared";
import { ComponentAdvertisementsCarouselType } from "@swo/storefront";

import { nonEmptyArray } from "fp-ts";
import { pipe } from "fp-ts/lib/function";
import {
  VisualCarouselComponent,
  VisualCarouselComponentProps,
} from "../VisualCarouselComponent/VisualCarouselComponent";
import { getFocalPoint } from "../_shared-components/image-related/ImageWithFocalPoint";
import { getComponentCMSClassname } from "../cms/edit-overlay/component-hook-class";

export const AdvertisementsCarouselComponent: ReactTFC<
  ComponentAdvertisementsCarouselType & ContentfulComponentCMSHook
> = props => {
  const items: VisualCarouselComponentProps["elements"] = pipe(
    props.items,
    nonEmptyArray.map(el => {
      const focalPoint = getFocalPoint(el.background);

      return {
        key: el.id,
        backgroundImage: {
          sys: {
            id: el.background.image.sys.id,
          },
          url: el.background.image.url,
          title: el.background.image.description || el.background.image.title,
          backgroundPositionCssString: focalPoint?.asCssString(),
        },
        headline: el.headline,
        buttons: el.callToActions,
      };
    }),
  );

  return (
    <div
      css={css`
        position: relative;
      `}
      className={getComponentCMSClassname(props?.sys?.id)}
    >
      <VisualCarouselComponent elements={items} autoSlideMs={3000} />
    </div>
  );
};
